/* Project Import will be here */
import { post, IRequest } from '../index';
import {
	IAddCategoryModel, IGetBrandListModel, IAddBrandModel, IAddOrUpdateProductModel,
	IFilterProductsByCategoryIdsModel, IGetAllStoreProducts, IGetSearchStoreProducts
} from 'models/storeProducts';
/* Project Import will be here */

export const getCategoryListApi = () => {
	const request: IRequest = { subUrl: '/retailer/categories' };
	return post(request);
};

export const addCategoryApi = (data: IAddCategoryModel) => {
	const request: IRequest = { subUrl: '/retailer/addcategory', data };
	return post(request);
};

export const getBrandListApi = (data: IGetBrandListModel) => {
	const request: IRequest = { subUrl: '/retailer/brands', data };
	return post(request);
};

export const addBrandApi = (data: IAddBrandModel) => {
	const request: IRequest = { subUrl: '/retailer/addbrand', data };
	return post(request);
};

export const addOrUpdateProductApi = (data: IAddOrUpdateProductModel) => {
	const request: IRequest = { subUrl: '/retailer/addorupdateproduct', data };
	return post(request);
};

export const filterProductsByCategoryIdsApi = (data: IFilterProductsByCategoryIdsModel) => {
	const request: IRequest = { subUrl: '/retailer/products', data };
	return post(request);
};

export const getAllStoreProducts = (data: IGetAllStoreProducts) => {
	const request: IRequest = { subUrl: '/retailer/products', data };
	return post(request);
};

export const getSearchStoreProductsApi = (data: IGetSearchStoreProducts) => {
	const request: IRequest = { subUrl: '/retailer/products', data };
	return post(request);
};